type IconProps = { className?: string }

const SVG_ROOT = {
  xmlns: 'http://www.w3.org/2000/svg',
  width: 24,
  height: 24,
  fill: 'none' as const,
  'aria-hidden': true as const,
}

export function IconSmartphone({ className }: IconProps) {
  return (
    <svg className={className} viewBox="0 0 24 24" {...SVG_ROOT}>
      <rect x="7" y="2.5" width="10" height="19" rx="2.5" stroke="currentColor" strokeWidth="1.75" />
      <circle cx="12" cy="18.5" r="0.75" fill="currentColor" />
    </svg>
  )
}

export function IconFingerprint({ className }: IconProps) {
  return (
    <svg className={className} viewBox="0 0 24 24" {...SVG_ROOT}>
      <path
        d="M12 11c1.66 0 3-1.34 3-3S13.66 5 12 5 9 6.34 9 8s1.34 3 3 3Z"
        stroke="currentColor"
        strokeWidth="1.75"
      />
      <path
        d="M6.5 12.5c0-3.04 2.46-5.5 5.5-5.5M17.5 12.5c0 3.87-3.13 7-7 7"
        stroke="currentColor"
        strokeWidth="1.75"
        strokeLinecap="round"
      />
    </svg>
  )
}

export function IconShieldCheck({ className }: IconProps) {
  return (
    <svg className={className} viewBox="0 0 24 24" {...SVG_ROOT}>
      <path
        d="M12 3 20 6v6c0 5-3.5 9.5-8 9-4.5-.5-8-4-8-9V6l8-3Z"
        stroke="currentColor"
        strokeWidth="1.75"
        strokeLinejoin="round"
      />
      <path d="m9 12 2 2 4-4" stroke="currentColor" strokeWidth="1.75" strokeLinecap="round" strokeLinejoin="round" />
    </svg>
  )
}

export function IconRadio({ className }: IconProps) {
  return (
    <svg className={className} viewBox="0 0 24 24" {...SVG_ROOT}>
      <path d="M4.5 8.5 12 16l7.5-7.5" stroke="currentColor" strokeWidth="1.75" strokeLinecap="round" />
      <path d="M7 12.5 12 17l5-5" stroke="currentColor" strokeWidth="1.75" strokeLinecap="round" />
      <circle cx="12" cy="19" r="1.25" fill="currentColor" />
    </svg>
  )
}

export function IconLock({ className }: IconProps) {
  return (
    <svg className={className} viewBox="0 0 24 24" {...SVG_ROOT}>
      <rect x="5" y="11" width="14" height="10" rx="2" stroke="currentColor" strokeWidth="1.75" />
      <path d="M8 11V8a4 4 0 0 1 8 0v3" stroke="currentColor" strokeWidth="1.75" strokeLinecap="round" />
    </svg>
  )
}

export function IconCreditCard({ className }: IconProps) {
  return (
    <svg className={className} viewBox="0 0 24 24" {...SVG_ROOT}>
      <rect x="3" y="6" width="18" height="12" rx="2.5" stroke="currentColor" strokeWidth="1.75" />
      <path d="M3 10h18" stroke="currentColor" strokeWidth="1.75" />
    </svg>
  )
}

export function IconBriefcase({ className }: IconProps) {
  return (
    <svg className={className} viewBox="0 0 24 24" {...SVG_ROOT}>
      <rect x="3" y="8" width="18" height="12" rx="2" stroke="currentColor" strokeWidth="1.75" />
      <path d="M8 8V6a2 2 0 0 1 2-2h4a2 2 0 0 1 2 2v2" stroke="currentColor" strokeWidth="1.75" />
    </svg>
  )
}

export function IconCopy({ className }: IconProps) {
  return (
    <svg className={className} viewBox="0 0 24 24" {...SVG_ROOT}>
      <rect x="9" y="9" width="11" height="11" rx="2" stroke="currentColor" strokeWidth="1.75" />
      <path d="M5 15V5a2 2 0 0 1 2-2h10" stroke="currentColor" strokeWidth="1.75" strokeLinecap="round" />
    </svg>
  )
}

export function IconShare({ className }: IconProps) {
  return (
    <svg className={className} viewBox="0 0 24 24" {...SVG_ROOT}>
      <path d="M12 16V4m0 0 4 4m-4-4-4 4" stroke="currentColor" strokeWidth="1.75" strokeLinecap="round" strokeLinejoin="round" />
      <path d="M4 20h16" stroke="currentColor" strokeWidth="1.75" strokeLinecap="round" />
    </svg>
  )
}

export function IconRefresh({ className }: IconProps) {
  return (
    <svg className={className} viewBox="0 0 24 24" {...SVG_ROOT}>
      <path d="M20 12a8 8 0 1 1-2.34-5.66" stroke="currentColor" strokeWidth="1.75" strokeLinecap="round" />
      <path d="M20 4v6h-6" stroke="currentColor" strokeWidth="1.75" strokeLinecap="round" strokeLinejoin="round" />
    </svg>
  )
}

export function IconBookmark({ className }: IconProps) {
  return (
    <svg className={className} viewBox="0 0 24 24" {...SVG_ROOT}>
      <path d="M6 4h12v16l-6-4-6 4V4Z" stroke="currentColor" strokeWidth="1.75" strokeLinejoin="round" />
    </svg>
  )
}

export function IconCalendar({ className }: IconProps) {
  return (
    <svg className={className} viewBox="0 0 24 24" {...SVG_ROOT}>
      <rect x="4" y="5" width="16" height="15" rx="2" stroke="currentColor" strokeWidth="1.75" />
      <path d="M8 3v4M16 3v4M4 10h16" stroke="currentColor" strokeWidth="1.75" strokeLinecap="round" />
    </svg>
  )
}

export function IconScanSearch({ className }: IconProps) {
  return (
    <svg className={className} viewBox="0 0 24 24" {...SVG_ROOT}>
      <circle cx="11" cy="11" r="6.5" stroke="currentColor" strokeWidth="1.75" />
      <path d="M16 16l4.5 4.5" stroke="currentColor" strokeWidth="1.75" strokeLinecap="round" />
      <path d="M11 8.5v5M8.5 11h5" stroke="currentColor" strokeWidth="1.75" strokeLinecap="round" />
    </svg>
  )
}

export function IconLoaderCircle({ className }: IconProps) {
  return (
    <svg className={className} viewBox="0 0 24 24" {...SVG_ROOT}>
      <path
        d="M12 3a9 9 0 1 1-6.36 2.64"
        stroke="currentColor"
        strokeWidth="1.75"
        strokeLinecap="round"
      />
    </svg>
  )
}

export function IconClose({ className }: IconProps) {
  return (
    <svg className={className} viewBox="0 0 24 24" {...SVG_ROOT}>
      <path d="M7 7l10 10M17 7 7 17" stroke="currentColor" strokeWidth="2" strokeLinecap="round" />
    </svg>
  )
}

export function checkIconForId(id: string) {
  switch (id) {
    case 'imei':
      return IconSmartphone
    case 'device':
      return IconFingerprint
    case 'blacklist':
      return IconShieldCheck
    case 'carrier':
      return IconRadio
    case 'lock':
      return IconLock
    case 'finance':
      return IconCreditCard
    case 'mdm':
    case 'android':
      return IconBriefcase
    default:
      return IconSmartphone
  }
}
